import { useState } from "react";

export default function useCities() {
  const [cities, setCities] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [currentCity, setCurrentCity] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Distance formula
  const getDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (val) => (val * Math.PI) / 180;

    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) ** 2;

    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // ✅ nearest city
  const findNearestCity = (cityList, userLat, userLng) => {
    let nearest = null;
    let minDist = Infinity;

    cityList.forEach((city) => {
      const dist = getDistance(
        userLat,
        userLng,
        parseFloat(city.latitude),
        parseFloat(city.longitude)
      );

      if (dist < minDist) {
        minDist = dist;
        nearest = city;
      }
    });

    return nearest;
  };

  // ✅ GPS
  const getUserLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  // ✅ AUTO DETECT
  const detectLocation = async (cityList) => {
    try {
      const position = await getUserLocation();

      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      console.log("📍 User Location 👉", { userLat, userLng });

      const nearest = findNearestCity(cityList, userLat, userLng);

      if (nearest) {
        const cityData = {
          name: nearest.name,
          latitude: nearest.latitude,
          longitude: nearest.longitude,
        };

        setCurrentCity(cityData);
        localStorage.setItem("selectedCity", JSON.stringify(cityData));

        console.log("✅ Auto Detected City 👉", cityData);
      }
    } catch (err) {
      console.log("❌ Location permission denied");
    }
  };

  // ✅ GET ALL CITIES
  const getAllCities = async () => {
    try {
      setLoading(true);

      const res = await fetch("https://admintest.medrphalabs.com/api/Lab/GetCities");
      const data = await res.json();
      const cityList = data?.data || data || [];

      setCities(cityList);

      console.log("📦 Cities API 👉", cityList);

      const saved = JSON.parse(localStorage.getItem("selectedCity"));

      if (saved) {
        setCurrentCity(saved);
        console.log("💾 Saved City 👉", saved);
      } else {
        detectLocation(cityList);
      }
    } catch (err) {
      console.log("❌ API Error", err);
      setCities([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ SEARCH
  const searchCities = async (query) => {
    try {
      const res = await fetch(
        `https://online-tech.in/api/Lab/GetCities?search=${query}`
      );
      const data = await res.json();

      console.log("🔍 Search Result 👉", data);

      setSuggestions(data?.data || data || []);
    } catch (err) {
      console.log("❌ Search Error", err);
      setSuggestions([]);
    }
  };

  // ✅ MANUAL SELECT
  const selectCity = (city) => {
    const cityData = {
      name: city?.cityName || city?.name,
      latitude: city?.latitude,
      longitude: city?.longitude,
    };

    setCurrentCity(cityData);
    localStorage.setItem("selectedCity", JSON.stringify(cityData));

    console.log("👉 Selected City (Manual) 👉", cityData);
  };

  return {
    cities,
    suggestions,
    currentCity,
    loading,
    setSuggestions,
    getAllCities,
    searchCities,
    selectCity,
    detectLocation,
  };
}